import { render, staticRenderFns } from "./BasicLayoutComponent.vue?vue&type=template&id=19208fa6&scoped=true&"
import script from "./BasicLayoutComponent.vue?vue&type=script&lang=js&"
export * from "./BasicLayoutComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19208fa6",
  null
  
)

export default component.exports